type IReactionDisposer = () => void;

export default class ReactionsHandlerStore {
  reactions: Map<string, IReactionDisposer> = new Map<
    string,
    IReactionDisposer
  >();

  addReaction({
    key,
    reaction
  }: {
    key: string;
    reaction: IReactionDisposer;
  }): void {
    this.removeReaction({ key });

    this.reactions.set(key, reaction);
  }

  removeReaction({ key }): void {
    const prevDisposer = this.reactions.get(key);

    if (!prevDisposer) {
      return;
    }

    // Сначала убираем из map — disposer может снова вызвать remove/disposeAll.
    this.reactions.delete(key);
    prevDisposer();
  }

  disposeAll(): void {
    const disposers = Array.from(this.reactions.values());
    this.reactions.clear();
    disposers.forEach((disposer) => disposer());
  }
}
